var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control-sm",attrs:{"name":_vm.name}},[_c('option',{attrs:{"value":"","disabled":"","default":""}},[_vm._v("Selecione")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }